//TODO: For circles instead use shared-ui/question-result-icon and scale - will need to add empty circle when result empty

import * as constants from '../../constants';
import Test from '../../test';

const circleRadius = 8;
const circleStrokeWidth = 2;
const circleSpacing = 4;

export const sprite = new PIXI.Sprite();

Test.eventEmitter.on('TEST_NEXT_QUESTION', test => {
  populate(test.last5AnswerResults);
});

const text = new PIXI.Text('LAST 5:', {
  font: '12px Open Sans, Arial',
  fill: 0xFFFFFF,
});

const circles = new PIXI.Container();
circles.y = 15;

sprite.addChild(text);
sprite.addChild(circles);

function populate( results ) {
  circles.removeChildren();
  results.forEach(( result, i ) => {
    const c = new PIXI.Container();
    circles.addChild(c);
    c.x = i * ( circleSpacing + 2 * circleRadius );

    const g = new PIXI.Graphics();
    c.addChild(g);

    if ( typeof result === 'undefined' ) {
      const coord = circleRadius - circleStrokeWidth / 2;
      const r = circleRadius - circleStrokeWidth / 2;
      g
      .lineStyle(circleStrokeWidth, 0xFFFFFF, 0.5)
      .drawCircle(circleRadius, circleRadius, circleRadius - circleStrokeWidth / 2)
    } else {
      const fillColour = result ? constants.green : constants.red;
      const char = result ? constants.tick : constants.cross;

      g
      .beginFill(fillColour)
      .drawCircle(circleRadius, circleRadius, circleRadius)
      .endFill();

      const resultText = new PIXI.Text(char, { font: '12px Flaticons Stroke', fill: 0xFFFFFF, align: 'center' });
      resultText.anchor.set(0.5);
      resultText.position.set(circleRadius - 0.25, circleRadius + 1.25);
      c.addChild(resultText);
    }
  });
}
